import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const Modal = ({ title, isOpen, onClose, children, isDarkMode }) => {
    
    // Lock background scroll
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        // Cleanup on unmount
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);

    if (!isOpen) return null;
    
    // Theme colors
    const colors = {
        modalBackground: isDarkMode ? '#1a1a1a' : '#ffffff',
        modalHeader: isDarkMode ? '#1e293b' : '#e5edff',
    };

    return (
        <div className=" fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
            <div className="w-full h-max-[80vh] overflow-y-auto max-h-[calc(80vh-72px)] max-w-lg rounded-lg shadow-lg overflow-hidden" style={{ backgroundColor: colors.modalBackground }}>
                <div className="flex justify-between items-center px-6 py-4" style={{ backgroundColor: colors.modalHeader }}>
                    <h2 className={`text-xl ${isDarkMode?'text-white': 'text-gray-800'} poppins-extrabold`}>{title}</h2>
                    <button
                        onClick={onClose}
                        className="p-1 rounded-full hover:bg-blue-200 dark:hover:bg-blue-800 transition">
                        <X size={20} style={{ color: colors.text }} />
                    </button>
                </div>
                <div className="p-6">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Modal